import React, { useState } from 'react';

import Bell from './svgs/Bell';

const Accordion = ({ shortDescription, detailedDescription }) => {
  const [accordionOpen, setAccordionOpen] = useState(false);

  const toggleAccordion = () => {
    setAccordionOpen(!accordionOpen);
  };

  return (
    <section className="page-section accordion-container">
      <div className="page-section__wrapper clearfix">
        <div className="card card--action-right mb0 card-group--noshadow accordion">
          <div>
            <div className="circle circle--appointments circle-small">
              <span className="svg-icon svg-icon--30 color--white" aria-hidden="true">
                <Bell />
              </span>
            </div>
          </div>
          <div className="card__content">
            <p className="mb0">{shortDescription}</p>
          </div>
          <div className="card__action">
            <button
              type="button"
              aria-expanded={accordionOpen}
              className="button--text"
              onClick={toggleAccordion}
            >
              <abbr title="View Details" id="view_details">
                {accordionOpen ? 'Hide Details' : 'View Details'}
              </abbr>
              <span
                className={`nav-primary__icon icon-arrow-down-mobile${
                  accordionOpen ? ' nav-primary__icon--is-open' : ''
                }`}
              />
            </button>
          </div>
        </div>
        <div className={`accordion-content${accordionOpen ? ' is-active' : ''}`}>
          <p>{detailedDescription}</p>
        </div>
      </div>
    </section>
  );
};

export default Accordion;
